export const identity = (x) => x;
export const accessor = (key) => (item) => item[key];

export const getCSRFParam = () =>
  document.querySelector('meta[name="csrf-param"]').getAttribute("content");

export const getCSRFToken = () =>
  document.querySelector('meta[name="csrf-token"]').getAttribute("content");
